export default "__VITE_ASSET__45aa394a__"